import React from 'react';
import { CaseHeader } from '../components/CaseHeader';
import { DiscoveryFilters } from '../components/DiscoveryFilters';
import { DiscoveryTable } from '../components/DiscoveryTable';
export function DiscoveryPage() {
  return <div className="flex flex-col h-full w-full overflow-hidden bg-navy" data-id="element-287">
      <CaseHeader data-id="element-288" />
      <DiscoveryFilters data-id="element-289" />
      <DiscoveryTable data-id="element-290" />
    </div>;
}